module.exports = __webpack_public_path__ + "files/bf1dee80a5d4a52724ba9fa15dd64bb2.png";